<template>
  <div
    class="nav-bar-box"
    id="nav-bar-box"
    ref="navBarBox"
    :class="{ 'nav-scrolled': isScrolled }"
    :style="{
      background: `rgba(255, 255, 255, ${scrollProgress * 0.8})`,
      backdropFilter: `blur(${scrollProgress * 20}px)`,
      WebkitBackdropFilter: `blur(${scrollProgress * 20}px)`,
      boxShadow:
        scrollProgress > 0
          ? `0 1px 15px rgba(0, 0, 0, ${scrollProgress * 0.08})`
          : 'none',
    }"
  >
    <img
      :src="
        currentLocale === 'zh'
          ? require('@/assets/img/pc/nav-logo.png')
          : require('@/assets/img/pc/nav-logo-en.png')
      "
      class="nav-bar-logo"
    />
    <div class="nav-right">
      <nav class="nav-links">
        <a
          href="#hero"
          class="nav-link"
          :class="{ active: activeSection === 'hero' }"
          @click.prevent="scrollToSection('hero')"
          >{{ $t('nav.home') }}</a
        >
        <a
          href="#about"
          class="nav-link"
          :class="{ active: activeSection === 'about' }"
          @click.prevent="scrollToSection('about')"
          >{{ $t('nav.about') }}</a
        >
        <a
          href="#business"
          class="nav-link"
          :class="{ active: activeSection === 'business' }"
          @click.prevent="scrollToSection('business')"
          >{{ $t('nav.services') }}</a
        >
        <a
          href="#platform"
          class="nav-link"
          :class="{ active: activeSection === 'platform' }"
          @click.prevent="scrollToSection('platform')"
          >{{ $t('nav.products') }}</a
        >
        <a
          href="#computing"
          class="nav-link"
          :class="{ active: activeSection === 'computing' }"
          @click.prevent="scrollToSection('computing')"
          >{{ $t('nav.computing') }}</a
        >
        <a
          href="#news"
          class="nav-link"
          :class="{ active: activeSection === 'news' }"
          @click.prevent="scrollToSection('news')"
          >{{ $t('nav.news') }}</a
        >
      </nav>
      <!-- <div class="nav-actions"> -->
      <RoundedButton
        :showArrow="false"
        :height="32"
        :width="96"
        :borderRadius="16"
        :text="$t('nav.contact')"
        @click.prevent="scrollToSection('contact')"
      />
      <!-- </div> -->
      <LanaugeSwitch class="lanauge-switch" />
    </div>
  </div>
</template>

<script>
import { useI18n } from 'vue-i18n';
import RoundedButton from '@/components/RoundedButton/index.vue';
import LanaugeSwitch from '@/components/LanaugeSwitch/index.vue';

export default {
  name: 'NavBar',
  components: {
    RoundedButton,
    LanaugeSwitch,
  },
  data() {
    return {
      isScrolled: false,
      activeSection: 'hero',
      scrollProgress: 0, // 滚动进度 0-1
      navHeight: 90, // 导航栏高度，随窗口变化动态计算
    };
  },
  mounted() {
    this.handleScroll();
    window.addEventListener('scroll', this.handleScroll);

    // 初始计算导航栏高度，并监听窗口变化
    this.computeNavHeight();
    window.addEventListener('resize', this.handleResize);

    // 将组件方法暴露到全局，供其他组件调用
    window.navBarMethods = {
      scrollToSection: this.scrollToSection,
      updateActiveSection: this.updateActiveSection,
      getActiveSection: () => this.activeSection,
      getScrollProgress: () => this.scrollProgress,
    };
  },
  unmounted() {
    window.removeEventListener('scroll', this.handleScroll);
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    handleResize() {
      this.computeNavHeight();
      this.updateActiveSection();
    },
    computeNavHeight() {
      this.$nextTick(() => {
        const nav = this.$refs.navBarBox;
        if (nav && nav.offsetHeight) {
          this.navHeight = nav.offsetHeight;
        }
      });
    },
    handleScroll() {
      this.isScrolled = window.scrollY > 50;

      this.updateActiveSection();
      this.updateScrollProgress();
    },
    updateScrollProgress() {
      // 计算滚动进度，在 0-200px 范围内从透明渐变到毛玻璃
      const maxScroll = 200;
      this.scrollProgress = Math.min(window.scrollY / maxScroll, 1);
    },
    updateActiveSection() {
      const sections = [
        'hero',
        'about',
        'partners',
        'business',
        'platform',
        'computing',
        'facilities',
        'computing-facilities',
        'news',
        'contact',
      ];
      for (let i = sections.length - 1; i >= 0; i--) {
        const section = document.getElementById(sections[i]);
        if (section) {
          const rect = section.getBoundingClientRect();
          if (rect.top <= this.navHeight + 5) {
            // console.log('sections[i]:', sections[i], this.navHeight);
            this.activeSection = sections[i];
            break;
          }
        }
      }
    },
    scrollToSection(sectionId) {
      const element = document.getElementById(sectionId);
      if (!element) return;

      // 计算包含滚动偏移的目标位置
      const rectTop = element.getBoundingClientRect().top;
      const pageTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop ||
        0;
      const targetTop = rectTop + pageTop - this.navHeight;

      window.scrollTo({
        top: targetTop,
        behavior: 'smooth',
      });
    },
  },
};
</script>

<style lang="scss" scoped>
// @import '@/css/pc/nav.scss';

.nav-bar-box {
  z-index: 1000;
  height: 90px;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  transition: all 0.3s ease;
  // padding: 0 360px;
}
.nav-bar-logo {
  width: 150px;
  margin-left: 360px;
}

.nav-right {
  display: flex;
  align-items: center;
  //   gap: 40px;
  margin-right: 360px;
}

.nav-links {
  display: flex;
  //   gap: 32px;
  font-size: 14px;
}

.nav-link {
  text-decoration: none;
  color: #3d3d40;
  font-size: 16px;

  margin-right: 40px;
  transition: color 0.3s ease;

  &:hover {
    // color: var(--primary-nav-hover-color);
    color: #005fe6;
  }

  &.active {
    font-weight: 500;
    color: var(--primary-text-color);
    text-decoration: underline;
    text-underline-offset: 8px; // 设置下划线与文字的距离
    text-decoration-thickness: 2px; // 设置下划线的粗细
  }
}

.nav-actions {
  display: flex;
  align-items: center;
}

.btn-contact {
  background: #1890ff;
  color: white;
  border: none;
  padding: 12px 24px;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  // transition: background-color 0.3s ease;

  &:hover {
    background: #40a9ff;
  }
}

.language-selector {
  position: relative;
}

.btn-language {
  background: white;
  color: #333;
  border: 1px solid #d9d9d9;
  padding: 10px 16px;
  border-radius: 6px;
  font-size: 14px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  transition: border-color 0.3s ease;

  &:hover {
    border-color: #1890ff;
  }
}

.globe-icon {
  font-size: 16px;
}

.language-dropdown {
  position: absolute;
  top: 100%;
  right: 0;
  background: white;
  border: 1px solid #d9d9d9;
  border-radius: 6px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  min-width: 120px;
  z-index: 1000;
  display: none;
}

.language-selector:hover .language-dropdown {
  display: block;
}

.dropdown-item {
  padding: 12px 16px;
  cursor: pointer;
  transition: background-color 0.3s ease;

  &:hover {
    background: #f5f5f5;
  }

  &:first-child {
    border-radius: 6px 6px 0 0;
  }

  &:last-child {
    border-radius: 0 0 6px 6px;
  }
}
.lanauge-switch {
  margin-left: 15px;
}
</style>
